import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'rd-panel-accordion',
  templateUrl: './panel-accordion.component.html',
  styleUrls: ['./panel-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PanelAccordionComponent {
  @HostBinding('class.rd-panel-accordion') componentClass = true;
  @Input() title: string;
  @Input() bodyText: string;
  @Input() bodyContent: TemplateRef<any>;

  toggleIcon: string;
  panelState = 1;

  constructor(private cdr: ChangeDetectorRef) {
    this.toggleIcon = this.getToggleIconName('down');
  }

  triggerOpenedPanelStateEvent(resetIndex: number): void {
    this.panelState = resetIndex;
    this.panelState++;
    this.toggleIcon = this.getToggleIconName();
    this.cdr.detectChanges();
  }

  triggerClosedPanelStateEvent(): void {
    this.panelState--;
    this.toggleIcon = this.getToggleIconName();
  }

  private getToggleIconName(initialValue?: string): string {
    const direction = initialValue || this.panelState === 0 ? `down` : `up`;
    return `icon-chevron-${direction}`;
  }
}
